// @mui material components
import React from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

// Presentation page sections
import InformationHome from "pages/Servicii/ServiciiSpeciale/CuratenieCentreDeAfaceri/sections/sections/InformationHome";
import TestimonialsHome from "pages/Homepage/sections/TestimonialsHome";
import HeroSection from "pages/Servicii/ServiciiSpeciale/CuratenieCentreDeAfaceri/sections/sections/HeroSection";

function CuratenieCentreDeAfaceri() {
    return (
        <>
            <Helmet>
                <title>Curățenie și Mentenanță Centre de Afaceri | Soluții Corporate</title>
                <meta
                    name="description"
                    content="Servicii integrate de curățenie pentru clădiri de birouri și centre de afaceri. Standarde înalte de calitate și personal calificat pentru managementul curățeniei."
                />
                <link
                    rel="canonical"
                    href="https://doral-cleaning.ro/curatenie-centre-de-afaceri/"
                />
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "LocalBusiness",
                      "@id": "https://doral-cleaning.ro/#business",
                      "name": "Doral Cleaning - Servicii profesionale de curatenie",
                      "url": "https://doral-cleaning.ro/",
                      "telephone": "0730 407 322",
                      "foundingDate": "2006",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Calea Șerban Vodă 82, Sector 4",
                        "addressLocality": "București",
                        "postalCode": "040213",
                        "addressCountry": "RO"
                      },
                      "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 44.4202372718721,
                        "longitude": 26.10209372955662
                      },
                      "areaServed": [
                        { "@type": "City", "name": "București" },
                        { "@type": "AdministrativeArea", "name": "Județul Ilfov" },
                        { "@type": "City", "name": "Voluntari" },
                        { "@type": "City", "name": "Pantelimon" },
                        { "@type": "City", "name": "Popești-Leordeni" },
                        { "@type": "City", "name": "Bragadiru" },
                        { "@type": "City", "name": "Măgurele" },
                        { "@type": "City", "name": "Chitila" },
                        { "@type": "City", "name": "Buftea" },
                        { "@type": "City", "name": "Otopeni" }
                      ]
                    }
                    `}
                </script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    zIndex: 1,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <TestimonialsHome />
                <InformationHome />
            </Card>
        </>
    );
}

export default CuratenieCentreDeAfaceri;
